import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeLeft12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconEdgeLeft12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.445 10.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M5.97 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M.8 9a.5.5 0 0 0 1 0V3a.5.5 0 1 0-1 0zm9.62-1.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M9.67 6a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m.75-3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-5.2-1.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M3.745 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-.75-7.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m5.2-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeLeft12);
